import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Switch,Redirect  } from "react-router-dom";
import Header from './Header/Header';
import Sidebar from './Sidebar/Sidebar';
import Home from './Home/Home';
import Clientes from './Clientes/Clientes';
import Cliente from './Clientes/Cliente';
import Pedidos from './Pedidos/Pedidos';
import Pedido from './Pedidos/Pedido';
import Productos from './Productos/Productos';
import Producto from './Productos/Producto';
import Correo from './Correo/Correo';
import Read from './Correo/Read';
import Nuevo from './Correo/New';
import Servicios from './Servicios/Servicios';
import Disenos from './Servicios/Disenos';
import Diseno from './Servicios/Diseno';
import Login from './Login/Login';

class App extends Component {
  constructor(props){
    super(props);
    this.state = {
      
    }
  }
  render() {
    return (
      <div>
        <Header />
           { (localStorage.getItem('TOKEN') == null || localStorage.getItem('TOKEN') == '')  ? (
             <Router>
               <div className="w3-main">
                <Switch>
                  <Route path="/" component={ Login }/>
                  <Route path="/:page" component={ Login }/>
                </Switch>
               </div>
             </Router>
           ) : (
               
            <Router>
              <div>
              <Sidebar />
              <div className="w3-main" style={{marginLeft:'300px'}}>
              
                <Switch>
                  <Route exact path="/" component={ Home }/>
                  <Route exact path="/clientes" component={ Clientes }/>
                  <Route exact path="/clientes/:id" component={ Cliente }/>
                  <Route exact path="/pedidos" component={ Pedidos }/>
                  <Route exact path="/pedidos/:id" component={ Pedido }/>
                  <Route exact path="/productos" component={ Productos }/>
                  <Route exact path="/productos/:id" component={ Producto }/>
                  <Route exact path="/correos" component={ Correo }/>
                  <Route exact path="/correo/:id" component={ Read }/>
                  <Route exact path="/nuevo/:id" component={ Nuevo }/>
                  <Route exact path="/servicios" component={ Servicios }/>
                  <Route exact path="/disenos" component={ Disenos }/>
                  <Route exact path="/disenos/:id" component={ Diseno }/>
                </Switch>
               
              </div>
              </div>
          </Router>
        
           )}
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js